jQuery(function($) {
  $('form#redeem_coupon').submit(function(e) {
    var form = this;

    e.preventDefault();

    $('#coupon_spinner').show();

    $.post(form.action, $(form).serialize(), null, 'json')
      .done(function(data) {
        // `data.description` contains text like:
        //    "50 per month transfered and 5 days retention until 2011-10-12"
        //
        // `data` is an object like:
        //    {"end_at"=>Wed, 12 Oct 2011 14:26:22 PDT -07:00, "transfer"=>53687091200,
        //      :description=>"50 per month transfered and 5 days retention until 2011-10-12",
        //      "coupon_code"=>"50GBFOR5", "retention"=>5}
        $('#coupon_status').text("Coupon redeemed for an extra " + data.description).removeClass('failure').addClass('success');
        $('#coupon_spinner').hide();
        $(form).hide();
        $('input#menu_full_refresh').val('true');
      })
      .fail(function(data) {
        if (data.responseText) {
          var errors = $.parseJSON(data.responseText).errors;

          // Something bad happened
          errors = _.map(errors, function(error) {
            return 'Coupon ' + error[1];
          });

          // `errors` is an array of reasons why the coupon could
          // not be redeemed
          $('#coupon_status').text(errors.join(', ')).removeClass('success').addClass('failure');
          $('#coupon_spinner').hide();
        }
      });
  });
});
